export function arrayToMap(array: any[], key: string): Record<string, any> {
  return array.reduce((map, item) => {
    const keyValue = item[key];
    if (keyValue) {
      map[keyValue] = item;
    }
    return map;
  }, {} as Record<string, any>);
}
